import { render, staticRenderFns } from "./analysisPostReportAdmin.vue?vue&type=template&id=908db036&scoped=true"
import script from "./analysisPostReportAdmin.vue?vue&type=script&lang=js"
export * from "./analysisPostReportAdmin.vue?vue&type=script&lang=js"
import style0 from "./analysisPostReportAdmin.vue?vue&type=style&index=0&id=908db036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908db036",
  null
  
)

export default component.exports